/** @format */
import { Injectable } from '@angular/core';
import { TranslationMarkupRendererFactory } from 'ngx-transloco-markup';
import { HtmlElementTranspiler } from '../common/html-element-transpiler';

export const SUB_START = new (class SubStart {})();
export const SUB_END = new (class SubEnd {})();

@Injectable()
export class SubTranspiler extends HtmlElementTranspiler {
    constructor(private readonly rendererFactory: TranslationMarkupRendererFactory) {
        super({
            rendererFactory,
            start: {
                search: '<sub>',
                token: SUB_START,
            },
            end: {
                search: '</sub>',
                token: SUB_END,
            },
            elementTag: 'sub',
        });
    }
}
